export class RestoreAccountAccessCondition {
    'effect';
    'restoreAccountIdentifiers';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "effect",
            "baseName": "effect",
            "type": "AccessConditionEffect",
            "format": ""
        },
        {
            "name": "restoreAccountIdentifiers",
            "baseName": "restoreAccountIdentifiers",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAccountAccessCondition.attributeTypeMap;
    }
    constructor() {
    }
}
